import { createModule } from '@Actions/utils';
import { SERVICE_ENDPOINT } from '@Apis/constants';

const CreateInProcessQualityCheck = createModule({
  base: 'CREATE_IN_PROCESS_QUALITY_CHECK',
  apiDetails: { ...SERVICE_ENDPOINT.IN_PROCESS_QUALITY_CHECK, method: 'put' },
  errors: { defaultError: true, customError: '' },
  enableNotification: true,
});

const GetInProcessQualityCheckList = createModule({
  base: 'GET_IN_PROCESS_QUALITY_CHECK_LIST',
  apiDetails: {
    ...SERVICE_ENDPOINT.IN_PROCESS_QUALITY_CHECK,
    url: `${SERVICE_ENDPOINT.IN_PROCESS_QUALITY_CHECK.url}/list`,
    method: 'get',
  },
  errors: { defaultError: true, customError: '' },
});
const GetInProcessQualityCheckById = createModule({
  base: 'GET_IN_PROCESS_QUALITY_CHECK_BY_ID',
  apiDetails: SERVICE_ENDPOINT.GET_IN_PROCESS_QUALITY_CHECK_BY_ID({}),
  errors: { defaultError: true, customError: '' },
});

const CancelInProcessQualityCheck = createModule({
  base: 'CANCEL_IN_PROCESS_QUALITY_CHECK',
  apiDetails: {
    ...SERVICE_ENDPOINT.IN_PROCESS_QUALITY_CHECK,
    url: `${SERVICE_ENDPOINT.IN_PROCESS_QUALITY_CHECK.url}/status`,
    method: 'put',
  }, errors: { defaultError: true, customError: '' },
  enableNotification: true,
});

export {
  CreateInProcessQualityCheck,
  GetInProcessQualityCheckList,
  CancelInProcessQualityCheck,
  GetInProcessQualityCheckById,
};
